// Mock data for Afro-Latino marketplace

export const mockProducts = [
  {
    id: "prod-001",
    name: "Nigerian Jollof Rice Mix",
    price: 12.99,
    image:
      "https://images.unsplash.com/photo-1665332195309-9d75071138f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
    category: "Grains & Flours",
    culture: "African",
    country: "Nigeria",
    region: "West Africa",
    description:
      "Authentic Nigerian Jollof rice spice blend with tomatoes and peppers",
    inStock: true,
    featured: true,
  },
  {
    id: "prod-002",
    name: "Mexican Adobo Seasoning",
    price: 8.99,
    image:
      "https://images.unsplash.com/photo-1640719028782-8230f1bdc42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
    category: "Spices & Herbs",
    culture: "Latino",
    country: "Mexico",
    region: "Central America",
    description:
      "Traditional Mexican adobo blend with chili, garlic, and cumin",
    inStock: true,
    featured: true,
  },
  {
    id: "prod-003",
    name: "Plantains (Green)",
    price: 4.99,
    image:
      "https://images.unsplash.com/photo-1665332561290-cc6757172890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
    category: "Fresh Produce",
    culture: "Fusion",
    country: "Multiple",
    region: "Multiple",
    description:
      "Fresh green plantains perfect for frying or baking. Loved from Lagos to Bogota",
    inStock: true,
    featured: true,
  },
  {
    id: "prod-004",
    name: "Suya Spice Blend",
    price: 10.99,
    image:
      "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
    category: "Spices & Herbs",
    culture: "African",
    country: "Nigeria",
    region: "West Africa",
    description:
      "Authentic Nigerian Suya spice blend with peanuts, ginger, and cayenne",
    inStock: true,
    featured: true,
  },
  {
    id: "prod-005",
    name: "Colombian Coffee",
    price: 15.99,
    image:
      "https://images.pexels.com/photos/35030234/pexels-photo-35030234.jpeg",
    category: "Beverages & Juices",
    culture: "Latino",
    country: "Colombia",
    region: "South America",
    description: "Premium Colombian coffee beans, medium roast",
    inStock: true,
    featured: false,
  },
  {
    id: "prod-006",
    name: "Ethiopian Coffee Beans",
    price: 16.99,
    image: "https://images.pexels.com/photos/3213283/pexels-photo-3213283.jpeg",
    category: "Beverages & Juices",
    culture: "African",
    country: "Ethiopia",
    region: "East Africa",
    description: "Single-origin Ethiopian coffee beans with floral notes",
    inStock: true,
    featured: false,
  },
  {
    id: "prod-007",
    name: "Goya Black Beans",
    price: 3.99,
    image:
      "https://images.unsplash.com/photo-1674669520816-c3c5615dfe51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
    category: "Pantry Staples",
    culture: "Latino",
    country: "Multiple",
    region: "Caribbean Latino",
    description: "Premium Goya black beans, ready to cook",
    inStock: true,
    featured: false,
  },
  {
    id: "prod-008",
    name: "Egusi Seeds",
    price: 9.99,
    image:
      "https://images.unsplash.com/photo-1665400808116-f0e6339b7e9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
    category: "Grains & Flours",
    culture: "African",
    country: "Nigeria",
    region: "West Africa",
    description: "Ground egusi (melon seeds) for authentic Nigerian soups",
    inStock: true,
    featured: false,
  },
];

export const mockCategories = [
  { id: "cat-001", name: "Fresh Produce", icon: "🥬", count: 45 },
  { id: "cat-002", name: "Spices & Herbs", icon: "🌶️", count: 78 },
  { id: "cat-003", name: "Grains & Flours", icon: "🌾", count: 32 },
  { id: "cat-004", name: "Frozen Foods", icon: "❄️", count: 28 },
  { id: "cat-005", name: "Snacks & Sweets", icon: "🍬", count: 56 },
  { id: "cat-006", name: "Oils, Sauces & Condiments", icon: "🫙", count: 64 },
  { id: "cat-007", name: "Beverages & Juices", icon: "🥤", count: 41 },
  { id: "cat-008", name: "Beauty & Wellness", icon: "💆", count: 23 },
  { id: "cat-009", name: "Home & Kitchen", icon: "🍳", count: 19 },
  { id: "cat-010", name: "Meal Kits", icon: "🍱", count: 12 },
  { id: "cat-011", name: "Pantry Staples", icon: "🥫", count: 87 },
];

export const mockRegions = [
  {
    id: "reg-001",
    name: "West Africa",
    countries: ["Nigeria", "Ghana", "Senegal"],
    image:
      "https://images.unsplash.com/photo-1665332195309-9d75071138f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "reg-002",
    name: "East Africa",
    countries: ["Kenya", "Ethiopia", "Tanzania"],
    image: "https://images.pexels.com/photos/3213283/pexels-photo-3213283.jpeg",
  },
  {
    id: "reg-003",
    name: "North Africa",
    countries: ["Morocco", "Egypt", "Tunisia"],
    image: "https://images.pexels.com/photos/106343/pexels-photo-106343.jpeg",
  },
  {
    id: "reg-004",
    name: "Central America",
    countries: ["Mexico", "Guatemala", "Costa Rica"],
    image:
      "https://images.unsplash.com/photo-1640719028782-8230f1bdc42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "reg-005",
    name: "South America",
    countries: ["Colombia", "Brazil", "Peru"],
    image:
      "https://images.pexels.com/photos/35030234/pexels-photo-35030234.jpeg",
  },
  {
    id: "reg-006",
    name: "Caribbean Latino",
    countries: ["Dominican Republic", "Puerto Rico", "Cuba"],
    image:
      "https://images.unsplash.com/photo-1674669520816-c3c5615dfe51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const mockRecipes = [
  {
    id: "rec-001",
    title: "Nigerian-Mexican Fusion Jollof Tacos",
    culture: "Fusion",
    image:
      "https://images.unsplash.com/photo-1640718862942-e18cc8873892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
    description:
      "A delicious fusion of Nigerian Jollof rice served in Mexican tacos",
    cookTime: "45 mins",
    difficulty: "Medium",
  },
  {
    id: "rec-002",
    title: "Ethiopian Coffee Ceremony",
    culture: "African",
    image: "https://images.pexels.com/photos/3213283/pexels-photo-3213283.jpeg",
    description:
      "Traditional Ethiopian coffee ceremony with roasting and brewing",
    cookTime: "60 mins",
    difficulty: "Advanced",
  },
  {
    id: "rec-003",
    title: "Dominican Platos Favoritos",
    culture: "Latino",
    image: "https://images.pexels.com/photos/2843394/pexels-photo-2843394.jpeg",
    description:
      "Classic Dominican dishes featuring rice, beans, and plantains",
    cookTime: "90 mins",
    difficulty: "Medium",
  },
];

export const mockTestimonials = [
  {
    id: "test-001",
    name: "Amara Johnson",
    location: "Moncton, NB",
    culture: "African",
    rating: 5,
    text: "Finally found authentic Nigerian ingredients in Moncton! The Egusi and Jollof rice mix are perfect.",
    avatar:
      "https://images.pexels.com/photos/6305734/pexels-photo-6305734.jpeg",
  },
  {
    id: "test-002",
    name: "Carlos Rodriguez",
    location: "Moncton, NB",
    culture: "Latino",
    rating: 5,
    text: "Best place for authentic Mexican and Colombian products. Fast delivery and great quality!",
    avatar:
      "https://images.pexels.com/photos/4965326/pexels-photo-4965326.jpeg",
  },
  {
    id: "test-003",
    name: "Fatima Santos",
    location: "Moncton, NB",
    culture: "Fusion",
    rating: 5,
    text: "Love discovering new fusion recipes. This marketplace brings my African and Latino heritage together.",
    avatar:
      "https://images.unsplash.com/photo-1578203657036-746e6c4eb3b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwY3Vpc2luZXxlbnwwfHx8fDE3NjUwNTMzNTJ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const mockMealKits = [
  {
    id: "kit-001",
    name: "Jollof Kit",
    price: 29.99,
    culture: "African",
    image:
      "https://images.unsplash.com/photo-1665332195309-9d75071138f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDB8MA&ixlib=rb-4.1.0&q=85",
    description: "Everything you need to make authentic Nigerian Jollof rice",
    serves: 4,
  },
  {
    id: "kit-002",
    name: "Mexican Taco Kit",
    price: 24.99,
    culture: "Latino",
    image:
      "https://images.unsplash.com/photo-1640719028782-8230f1bdc42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxMYXRpbiUyMEFtZXJpY2FuJTIwZm9vZHxlbnwwfHx8fDE3NjUwNTMzNDZ8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Authentic Mexican taco kit with tortillas, spices, and sauces",
    serves: 6,
  },
  {
    id: "kit-003",
    name: "Afro-Latino Fusion Box",
    price: 34.99,
    culture: "Fusion",
    image:
      "https://images.unsplash.com/photo-1724222907935-ad52b8e6f4dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwY3Vpc2luZXxlbnwwfHx8fDE3NjUwNTMzNTJ8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Curated fusion ingredients from both African and Latin American cuisines",
    serves: 4,
  },
];

// Cart management in localStorage
export const getCart = () => {
  const cart = localStorage.getItem("afrolatino_cart");
  return cart ? JSON.parse(cart) : [];
};

export const saveCart = (cart) => {
  localStorage.setItem("afrolatino_cart", JSON.stringify(cart));
};

export const addToCart = (product, quantity = 1) => {
  if (product.in_stock === false) {
    console.warn(
      "Attempted to add out of stock product to cart:",
      product.name
    );
    return getCart();
  }

  const cart = getCart();
  const existingItem = cart.find(
    (item) => item.product_id === product.product_id
  );

  if (existingItem) {
    existingItem.quantity += quantity;
  } else {
    cart.push({ ...product, quantity });
  }

  saveCart(cart);
  return cart;
};

export const removeFromCart = (productId) => {
  const cart = getCart().filter((item) => item.product_id !== productId);
  saveCart(cart);
  return cart;
};

export const updateCartQuantity = (productId, quantity) => {
  const cart = getCart();
  const item = cart.find((item) => item.product_id === productId);
  if (item) {
    item.quantity = quantity;
  }
  saveCart(cart);
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem("afrolatino_cart");
  return [];
};

export const getCartTotal = () => {
  const cart = getCart();
  return cart.reduce((total, item) => total + item.price * item.quantity, 0);
};

export const getCartCount = () => {
  const cart = getCart();
  return cart.reduce((count, item) => count + item.quantity, 0);
};
